

import React, { Component } from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import withAuth from '../../components/withAuth';
import { getCurrentFunctionName } from '../../performanceModeManager';
import CustomizedTextField from '../../components/Input/CustomizedTextField';

class AffairAdditionnalFields extends Component {

    constructor(props) {
        super(props);

        if (!props.affair)
            props.history.push("/affairs");
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        if (!this.props.affair)
            return null;

        return (
            <div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                <div className="col-lg-4 col-md-6 col-sm-12 col-12 control-margin-top">
                    <CustomizedTextField
                        id="business_user"
                        label="Commercial"
                        className="full_size light-disabled"
                        value={this.props.affair.business_user_id ? this.props.affair.business_user_id.name : ""}
                        margin="normal"
                    />
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 col-12 control-margin-top">
                    <CustomizedTextField
                        id="engineering-user"
                        label="Bureau d'étude"
                        className="full_size light-disabled"
                        value={this.props.affair.engineering_user_id ? this.props.affair.engineering_user_id.name : ""}
                        margin="normal"
                    />
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 col-12 control-margin-top">
                    <CustomizedTextField
                        id="site-manager"
                        label="Chef de chantier"
                        className="full_size light-disabled"
                        value={this.props.affair.site_manager_id ? this.props.affair.site_manager_id.name : ""}
                        margin="normal"
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        affair: state.affair.currentAffair,
    };
};

const mapDispatchToProps = () => {
    return {
    };
};

export default compose(withAuth, withRouter, connect(mapStateToProps, mapDispatchToProps))(AffairAdditionnalFields);
